import { useState } from "react";
import styled, { css } from "styled-components";

interface CheckboxProps {
  label: string;
  selected?: boolean;
  onChange?(value: any, label: string): void;
  forceSelfSelect?: boolean;
  initialSearchedList?: string[];
}

interface CheckboxBoxProps {
  isSelected: boolean;
}

export function Checkbox({ label, selected = false, onChange, forceSelfSelect = false, initialSearchedList = [] }: CheckboxProps) {
  
  const [isSelected, setIsSelected] = useState(!!initialSearchedList.find(i => i === label));

  function handleClick(select: boolean) {
    if(onChange){
      onChange(select, label);
    }
    setIsSelected(select);
  }

  function returnSelect() {
    if(!forceSelfSelect && onChange) return selected;
    return isSelected;
  }

  return (
    <Content onClick={() => handleClick(!returnSelect())}>
      <input
        type="checkbox"
        placeholder=""
        checked={returnSelect()}
      />
      <CheckboxBox isSelected={returnSelect()} />
      <CheckboxOption>{ label }</CheckboxOption>
    </Content>
  );
}

const Content = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  > input {
    display: none;
  }
`;

const CheckboxBox = styled.div<CheckboxBoxProps>`
  width: 30px;
  height: 30px;
  background-color: ${({ theme }) => theme.colors.gray.light};
  border: ${({ theme }) => `2px solid ${theme.colors.gray.dark}`};
  border-radius: 5px;
  position: relative;

  ${({ isSelected }) => isSelected && css`
    &::before {
      content: '';
      display: block;
      width: 16px;
      height: 16px;
      border-radius: 3px;
      background-color: ${({ theme }) => theme.colors.pink.light};
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  `}
`;

const CheckboxOption = styled.label`
  margin-left: 6px;
  font-size: 14px;
  max-width: 180px;
  line-height: 1;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.gray.darker };
`;
